up.compiler(".signature-pad-wrapper", function(element, data){
    const canvas = element.querySelector("canvas")
    const signaturePad = new SignaturePad(canvas);
    const clearButton = element.getElementsByClassName('signature-clear')
    const undoButton = element.getElementsByClassName('signature-undo')
    up.on (clearButton,"click", (event) => {
        event.preventDefault();
        signaturePad.clear();
    })
    up.on (undoButton,"click", (event) => {
        event.preventDefault();
        var data = signaturePad.toData();
        if (data) {
            data.pop(); // remove the last dot or line
            signaturePad.fromData(data);
        }
    })
})